import script from "./OrderHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderHeader.vue?vue&type=script&setup=true&lang=ts"

import "./OrderHeader.vue?vue&type=style&index=0&id=cf1e9952&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf1e9952"]])

export default __exports__